import React, { useState } from 'react';

interface AccordionProps {
    className?: string;
    header: React.ReactNode;
    children: React.ReactNode;
    ariaLabel?: string;
    iconStyle?: string;
    id?: string;
    headerTrailing?: React.ReactNode;
}

function Accordion({
    className,
    header,
    children,
    ariaLabel,
    iconStyle,
    id,
    headerTrailing,
}: AccordionProps) {
    const [open, setOpen] = useState(false);
    const toggleOpen = () => setOpen(currentOpen => !currentOpen);

    return (
        <section className={className}>
            <header className="o-accordion__header" id={id} onClick={toggleOpen}>
                <button
                    type="button"
                    onClick={event => {
                        event.stopPropagation();
                        toggleOpen();
                    }}
                    aria-expanded={open}
                    aria-label={ariaLabel ?? ''}
                >
                    <i
                        className={`
                        o-accordion__chevron
                        o-accordion__chevron--${open ? 'open' : 'closed'}
                        o-icon-chevron-right
                        c-what-accordion__icon ${iconStyle}`}
                    />
                </button>
                <div className="o-accordion__header-content">{header}</div>
                {headerTrailing && (
                    <div className="o-accordion__header-trailing">{headerTrailing}</div>
                )}
            </header>
            {open && children}
        </section>
    );
}

export default Accordion;
